import { render, staticRenderFns } from "./EnvironmentRecordView.vue?vue&type=template&id=495a1212"
import script from "./EnvironmentRecordView.vue?vue&type=script&lang=js"
export * from "./EnvironmentRecordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports